import type { SyncTwilioResult } from '../../services/callPhoneNumberService';

interface SyncResultModalProps {
  result: SyncTwilioResult;
  onClose: () => void;
}

export function SyncResultModal({ result, onClose }: SyncResultModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-sm mx-4">
        <div className="px-6 pt-6 pb-4">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Sync Results</h2>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Processed</span>
              <span className="font-medium">{result.totalProcessed}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">New</span>
              <span className="font-medium">{result.new}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Changed</span>
              <span className="font-medium">{result.changed}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Deleted</span>
              <span className="font-medium">{result.deleted}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
